import AreaSelectorMap from "./AreaSelectorMap";

export default AreaSelectorMap;
